import AppLayout from "../layout/AppLayout"

export default function OfficeActionPage() {
  return (
    <AppLayout title="Office action response">
      <div className="min-h-[24rem]" />
    </AppLayout>
  )
}
